import EmployeeRegisterService from "../service/EmployeeRegisterService";
import {
  POST_EMPLOYEE_DETAILS_REQUEST,
  POST_WORKPLACE_RELATIONSHIPS_REQUEST,
  POST_PREVIOUS_EMPLOYMENT_REQUEST,
  POST_EMPLOYEE_DEPENDENTS_REQUEST,
  POST_EMPLOYEE_QUALIFICATIONS_REQUEST,

  POST_EMPLOYEE_DETAILS_SUCCESS,
  POST_EMPLOYEE_QUALIFICATIONS_SUCCESS,
  POST_EMPLOYEE_DEPENDENTS_SUCCESS,
  POST_PREVIOUS_EMPLOYMENT_SUCCESS,
  POST_WORKPLACE_RELATIONSHIPS_SUCCESS,

  POST_EMPLOYEE_DETAILS_FAIL,
  POST_EMPLOYEE_QUALIFICATIONS_FAIL,
  POST_EMPLOYEE_DEPENDENTS_FAIL,
  POST_PREVIOUS_EMPLOYMENT_FAIL,
  POST_WORKPLACE_RELATIONSHIPS_FAIL,

  GET_EMPLOYEE_DETAILS_BY_USER_REQUEST,
  GET_EMPLOYEE_QUALIFICATIONS_REQUEST,
  GET_WORKPLACE_RELATIONSHIP_REQUEST,
  GET_EMPLOYEE_DEPENDENTS_REQUEST,
  GET_PREVIOUS_EMPLOYMENT_REQUEST,
  GET_EMPLOYEE_BY_SERVICENO_REQUEST,

  GET_EMPLOYEE_DETAILS_BY_USER_SUCCESS,
  GET_EMPLOYEE_QUALIFICATIONS_SUCCESS,
  GET_WORKPLACE_RELATIONSHIP_SUCCESS,
  GET_EMPLOYEE_DEPENDENTS_SUCCESS,
  GET_PREVIOUS_EMPLOYMENT_SUCCESS,
  GET_EMPLOYEE_BY_SERVICENO_SUCCESS,

  GET_EMPLOYEE_DETAILS_BY_USER_FAIL,
  GET_EMPLOYEE_QUALIFICATIONS_FAIL,
  GET_WORKPLACE_RELATIONSHIP_FAIL,
  GET_EMPLOYEE_DEPENDENTS_FAIL,
  GET_PREVIOUS_EMPLOYMENT_FAIL,
  GET_EMPLOYEE_BY_SERVICENO_FAIL
} from "../constants/EmployeeRegisterConstants";

//post actions
export const postEmployeeDetails = (data) => async (dispatch) => {
  try {
    dispatch({ type: POST_EMPLOYEE_DETAILS_REQUEST });

    const response = await EmployeeRegisterService.postEmployeeDetails(data);

    dispatch({
      type: POST_EMPLOYEE_DETAILS_SUCCESS,
      payload: response,
    });

    console.log("Inserted Successfully:", response);
  } catch (error) {
    console.error("Error in postEmployeeDetials Action:", error);
    dispatch({
      type: POST_EMPLOYEE_DETAILS_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to Insert Employee Details",
    });
  }
};

export const postEmployeeQualifications = (data) => async (dispatch) => {
  try {
    dispatch({ type: POST_EMPLOYEE_QUALIFICATIONS_REQUEST });
    const response =
      await EmployeeRegisterService.postEmployeeQualifications(data);

    dispatch({
      type: POST_EMPLOYEE_QUALIFICATIONS_SUCCESS,
      payload: response,
    });
    console.log("Inserted Successfully:", response);
  } catch (error) {
    console.error("Error in postEmployeeQualifications Action:", error);
    dispatch({
      type: POST_EMPLOYEE_QUALIFICATIONS_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to Insert Employee Qualifications",
    });
  }
};

export const postEmployeeDependents = (data) => async (dispatch) => {
  try {
    dispatch({ type: POST_EMPLOYEE_DEPENDENTS_REQUEST });
    const response = await EmployeeRegisterService.postEmployeeDependents(data);

    dispatch({
      type: POST_EMPLOYEE_DEPENDENTS_SUCCESS,
      payload: response,
    });
    console.log("Inserted Successfully:", response);
  } catch (error) {
    console.error("Error in postEmployeeDependent Action:", error);
    dispatch({
      type: POST_EMPLOYEE_DEPENDENTS_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to Insert Employee Dependents",
    });
  }
};

export const postPreviousEmployment = (data) => async (dispatch) => {
  try {
    dispatch({ type: POST_PREVIOUS_EMPLOYMENT_REQUEST });
    const response =
      await EmployeeRegisterService.postPreviousEmployement(data);

    dispatch({
      type: POST_PREVIOUS_EMPLOYMENT_SUCCESS,
      payload: response,
    });
    console.log("Inserted Successfully:", response);
  } catch (error) {
    console.error("Error in postPreviousEmployment Action", error);
    dispatch({
      type: POST_PREVIOUS_EMPLOYMENT_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to Insert Previous Employement",
    });
  }
};

export const postWorkplaceRelationships = (data) => async (dispatch) => {
  try {
    dispatch({ type: POST_WORKPLACE_RELATIONSHIPS_REQUEST });
    const response =
      await EmployeeRegisterService.postWorkplaceRelationships(data);

    dispatch({
      type: POST_WORKPLACE_RELATIONSHIPS_SUCCESS,
      payload: response,
    });
    console.log("Inserted SuccessFully:", response);
  } catch (error) {
    console.error("Error in postWorkplaceRelationships Action:", error);
    dispatch({
      type: POST_WORKPLACE_RELATIONSHIPS_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to Insert Workplace RelationShips",
    });
  }
};

//get actions
export const getAllEmployees = () => async (dispatch) => {
  try {
    dispatch({ type: GET_EMPLOYEE_DETAILS_BY_USER_REQUEST});
    const response = await EmployeeRegisterService.getAllEmployees();
    dispatch({
      type: GET_EMPLOYEE_DETAILS_BY_USER_SUCCESS,
      payload: response
    });
  } catch (error) {
    dispatch({
      type: GET_EMPLOYEE_DETAILS_BY_USER_FAIL,
      payload: error.response?.data?.message ||
      error.message ||
      "Failed to Fetch Employees"
    });
  }
};

export const getEmployeeByServiceNo = (serviceNo) => async (dispatch) => {
  try {
    dispatch({ type: GET_EMPLOYEE_BY_SERVICENO_REQUEST });
    const response = await EmployeeRegisterService.getEmployeeByServiceNo(serviceNo);
    dispatch({
      type: GET_EMPLOYEE_BY_SERVICENO_SUCCESS,
      payload: response
    });
    return {payload: response};
  } catch (error) {
    dispatch({
      type: GET_EMPLOYEE_BY_SERVICENO_FAIL,
      payload: error.response?.data?.message ||
      error.message ||
      "Failed to Fetch Employee"
    });
  }
};

export const getWorkplaceRelationships = (serviceNo) => async (dispatch) => {
  try {
    dispatch({ type: GET_WORKPLACE_RELATIONSHIP_REQUEST });
    const response = await EmployeeRegisterService.getWorkplaceRelationships(serviceNo);
    dispatch({
      type: GET_WORKPLACE_RELATIONSHIP_SUCCESS,
      payload: response
    });
        return {payload: response};
  } catch (error) {
    dispatch({
      type: GET_WORKPLACE_RELATIONSHIP_FAIL,
      payload: error.response?.data?.message ||
      error.message ||
      "Failed to Fetch Workplace Relationships"
    });
  }
};

export const getPreviousEmployment = (serviceNo) => async (dispatch) => {
  try {
    dispatch({ type: GET_PREVIOUS_EMPLOYMENT_REQUEST });
    const response = await EmployeeRegisterService.getPreviousEmployment(serviceNo);
    dispatch({
      type: GET_PREVIOUS_EMPLOYMENT_SUCCESS,
      payload: response
    });
        return {payload: response};
  } catch (error) {
    dispatch({
      type: GET_PREVIOUS_EMPLOYMENT_FAIL,
      payload: error.response?.data?.message ||
      error.message ||
      "Failed to Fetch Previous Employment"
    });
  }
};

export const getEmployeeDependents = (serviceNo) => async (dispatch) => {
  try {
    dispatch({type: GET_EMPLOYEE_DEPENDENTS_REQUEST });
    const response = await EmployeeRegisterService.getEmployeeDependents(serviceNo);
    dispatch({
      type: GET_EMPLOYEE_DEPENDENTS_SUCCESS,
      payload: response
    });
        return {payload: response};
  } catch (error) {
    dispatch({
      type: GET_EMPLOYEE_DEPENDENTS_FAIL,
      payload: error.response?.data?.message ||
      error.message ||
      "Failed to Fetch Employee Dependents"
    });
  }
};

export const getEmployeeQualifications = (serviceNo) => async (dispatch) => {
  try {
    dispatch({ type: GET_EMPLOYEE_QUALIFICATIONS_REQUEST });
    const response = await EmployeeRegisterService.getEmployeeQualifications(serviceNo);
    dispatch({
      type: GET_EMPLOYEE_QUALIFICATIONS_SUCCESS,
      payload: response
    });
        return {payload: response};
  } catch (error) {
    dispatch({
      type: GET_EMPLOYEE_QUALIFICATIONS_FAIL,
      payload: error.response?.data?.message ||
      error.message ||
      "Failed to Fetch Employee Qualifications"
    });
  }
};